export enum ChatEntryPoint {
	SEARCH_PAGE_AUTO_OPEN_CHAT = 'searchPageAutoOpenChat',
}
